/* eslint-disable react-hooks/exhaustive-deps */
import { Box, MenuItem, Select, Typography } from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';

import {
  FilteringState,
  IntegratedFiltering,
  IntegratedPaging,
  IntegratedSorting,
  PagingState,
  SortingState
} from '@devexpress/dx-react-grid';
import { Grid, PagingPanel, Table, TableFilterRow, TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
import { Button, InputAdornment, Paper, TableRow, TextField } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import SelectedCommentAndNote from './selectedCommentsAndNotes.component';
import { IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import { deleteClientComment, getAllClientComments, postClientComment } from 'modules/clients/clients.actions';
import { DELETE_CLIENT_COMMENT_FAILURE, POST_CLIENT_COMMENT_FAILURE } from 'modules/clients/types';
import { SearchableProperties } from './commentsAndNotesConstants.component';
import { showToast } from 'modules/layout/layout.actions';

export const formatDate = date => {
  if (!date) return '';
  try {
    const parsedDate = new Date(date);
    if (isNaN(parsedDate)) return '';

    // Format YYYY-MM-DD HH:MM:SS
    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const day = String(parsedDate.getDate()).padStart(2, '0');
    const hours = String(parsedDate.getHours()).padStart(2, '0');
    const minutes = String(parsedDate.getMinutes()).padStart(2, '0');
    const seconds = String(parsedDate.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  } catch {
    return '';
  }
};

export const createDefaultComment = (serviceOptionId, regardingOptionId = null, categoryId = 0, clientId) => {
  return {
    commentId: null,
    clientCommentId: null,
    clientRecordId: clientId,
    addedBy: 0,
    modifiedBy: 0,
    serviceId: serviceOptionId,
    regardingId: regardingOptionId,
    categorizationId: categoryId,
    subject: null,
    comment: null,
  };
};

const customFilterCell = props => {
  if (props.column?.type === 'dropdown') {
    return (
      <TableFilterRow.Cell {...props}>
        <Select
          value={props.filter ? props.filter.value : ''}
          onChange={event => {
            const value = event.target.value;
            props.onFilter(value ? { value, operation: 'equal' } : null);
          }}
          displayEmpty
          fullWidth
          variant="standard"
          sx={{ fontSize: '0.75rem' }}
        >
          <MenuItem value="" sx={{ fontSize: '0.75rem' }}>
            All
          </MenuItem>
          {props.column.options.map(option => (
            <MenuItem key={option.id} value={option.title} sx={{ fontSize: '0.75rem' }}>
              {option.title}
            </MenuItem>
          ))}
        </Select>
      </TableFilterRow.Cell>
    );
  }

  return <TableFilterRow.Cell {...props} />;
};

const createLookupMap = arr =>
  arr.reduce((acc, item) => {
    acc[item.id] = item.title;
    return acc;
  }, {});

const CommentsAndNotes = props => {
  const { clientId, details, viewMode = 'fullView', serviceOptionId, regardingOptionId, enumerations, filterString, isReadOnly = false, internalUsers } = props;

  const theme = createTheme({
    palette: {
      primary: COLOR_PRIMARY,
      secondary: COLOR_SECONDARY,
      warning: COLOR_WARNING
    }
  });

  const serviceOptions = enumerations?.allEnums?.authCommentService.filter(c => c.enumType === 2) || [];
  const regardingOptions = enumerations?.allEnums?.authCommentRegarding.filter(c => c.enumType === 2) || [];

  const serviceLookup = createLookupMap(serviceOptions);
  const regardingLookup = createLookupMap(regardingOptions);

  let allNotes = details && details?.clientDetails?.clientComments ? details.clientDetails?.clientComments.map((n) => { return n.info }) : [];

  const [isLoading, setIsLoading] = useState(false);
  const [isNewComment, setIsNewComment] = useState(false);
  const [selectedComment, setSelectedComment] = useState(null);

  const saveComment = async () => {
      setIsLoading(true);
      const resp = await props.postClientComment({
        clientRecordId: clientId,
        regardingId: '00000000-0000-0000-0000-000000000000',
        serviceId: '00000000-0000-0000-0000-000000000000'
      });
  
      if (resp.type === POST_CLIENT_COMMENT_FAILURE) {
        props.showToast('Failed to create comment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
      } else {
        props.showToast('Comment created successfully', TOAST_MESSAGE_SEVERITY_SUCCESS);
        setIsNewComment(false);
        const newest = resp.response[resp.response.length - 1];
  
        setSelectedComment(newest.info);
        setFilteredRows(resp.response.map((n) => { return n.info }));
      }
  
      setIsLoading(false);
  };
  
  useEffect(() => {

    if (viewMode === 'fullView' && allNotes.length > 0) {
      
      const filteredNotes = filterString ? allNotes.filter(note => note.serviceId === filterString) : allNotes;
      if (filteredNotes.length === 0) {
        setSelectedComment(null);
        return;
      }
      const newestComment = filteredNotes[filteredNotes.length - 1];

      setSelectedComment(newestComment);
    }

    if(details)
    {
      allNotes = details.clientDetails?.clientComments ? details.clientDetails?.clientComments.map((n) => { return n.info }) : [];
      allNotes.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
    }

  }, [details]);



  const onDeleteComment = async commentId => {
    setIsLoading(true);
    try {
      const resp = await props.deleteClientComment(commentId);
      if (resp.type === DELETE_CLIENT_COMMENT_FAILURE) {
        props.showToast('Failed to delete comment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
      } else {
        if (commentId === selectedComment?.commentId) {
          setSelectedComment(null);
        }
        setFilteredRows(resp.response.map((n) => { return n.info }))
      }
    } catch {
      props.showToast('Failed to delete comment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
    }
    setIsLoading(false);
  };

  const onRowClick = rowData => {
    setIsNewComment(false);
    setSelectedComment(rowData);
  };

  useEffect(() => {
    allNotes = details.clientDetails?.clientComments ? details.clientDetails?.clientComments.map((n) => { return n.info }) : [];
    allNotes.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
  }, [allNotes, details?.clientDetails?.clientComments]);


  const renderHeaderRow = row => {
    return (
      <TableRow sx={{ backgroundColor: '#41B7C0', '& .MuiButtonBase-root': { color: 'white !important' } }}>
        {row.children.map(c => {
          return c;
        })}
      </TableRow>
    );
  };

  const [sorting, setSorting] = useState([{ columnName: 'date', direction: 'desc' }]);

  const baseTableColumnExtensions = [
    { columnName: 'serviceId', width: 160 },
    { columnName: 'regardingId', width: 170 },
    { columnName: 'addedOn', width: 135 }
  ];

  const baseColumns = [
    {
      name: 'serviceId',
      title: 'Service',
      getCellValue: row => serviceOptions.find(opt => opt.id === row.serviceId)?.title || '',
      type: 'dropdown',
      options: serviceOptions
    },
    {
      name: 'regardingId',
      title: 'Regarding',
      getCellValue: row => regardingOptions.find(opt => opt.id === row.regardingId)?.title || '',
      type: 'dropdown',
      options: regardingOptions
    },
    { name: 'addedOn', title: 'Created Date', getCellValue: row => formatDate(row.addedOn) }
  ];

    const columns = baseColumns;
    const tableColumnExtensions = baseTableColumnExtensions;


  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [pageSizes] = useState([15, 20, 25]);
  const [filters, setFilters] = useState(
    serviceOptionId
      ? [{ columnName: 'serviceId', value: serviceOptions.find(s => s.id === serviceOptionId)?.title }]
      : regardingOptionId
      ? [{ columnName: 'regardingId', value: regardingOptions.find(s => s.id === regardingOptionId)?.title }]
      : []
  );
  const [filterText, setFilterText] = useState('');
  const [filteredRows, setFilteredRows] = useState(allNotes);

  useEffect(() => {
    setFilteredRows(handleFilterRowsChange());
  }, [filterText]);

    useEffect(() => {
    if (filterText === undefined) {
      setFilteredRows(allNotes);
    } else {
      handleFilterRowsChange();
    }
  }, [allNotes, details.clientDetails?.clientComments]);

  const handleFilterChange = e => {
    setFilterText(e.target.value);
  };

  const handleFilterRowsChange = () => {
    const searchText = filterText.trim().toLowerCase();
    if (!searchText) return allNotes;

    return allNotes.filter(note =>
      Object.entries(note).some(([key, value]) => {
        if (!SearchableProperties.has(key) || value === null) return false;

        let stringValue = value
          .toString()
          .trim()
          .toLowerCase();

        if (key === 'serviceId' && serviceLookup[value]) {
          stringValue = serviceLookup[value].toLowerCase();
        } else if (key === 'regardingId' && regardingLookup[value]) {
          stringValue = regardingLookup[value].toLowerCase();
        }

        return stringValue.includes(searchText);
      })
    );
  };

  const iconAdornment = {
    startAdornment: (
      <InputAdornment position="start">
        <FontAwesomeIcon size="1x" icon={['fas', 'fa-magnifying-glass']} color="gray" />
      </InputAdornment>
    )
  };

  return (
    <ThemeProvider theme={theme}>
      {isLoading && <FullscreenSpinner />}
      {!isLoading && viewMode === 'fullView' && (
        <Box display="flex" width="100%" height="100%">
          <Box sx={{ padding: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <TextField
                placeholder="Search..."
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <FontAwesomeIcon size="1x" icon={['fas', 'magnifying-glass']} color="gray" />
                    </InputAdornment>
                  )
                }}
                sx={{
                  width: '350px',
                  paddingBottom: '5px'
                }}
                value={filterText}
                onChange={e => handleFilterChange(e)}
              />
              <Button color="primary" variant="contained" sx={{ height: '36px' }} onClick={saveComment} disabled={isReadOnly}>
                Create Comment
              </Button>
            </Box>
            <Paper>
              <Grid rows={filteredRows} columns={columns}>
                <SortingState sorting={sorting} onSortingChange={setSorting} />
                <IntegratedSorting />
                <PagingState
                  currentPage={currentPage}
                  onCurrentPageChange={setCurrentPage}
                  pageSize={pageSize}
                  onPageSizeChange={setPageSize}
                />
                <FilteringState filters={filters} onFiltersChange={setFilters} />
                <IntegratedFiltering />
                <IntegratedPaging />
                <Table
                  columnExtensions={tableColumnExtensions}
                  cellComponent={props => {
                    const { column, row, ...restProps } = props;
                    if (column.name === 'serviceId') {
                      return (
                        <Table.Cell {...restProps}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <IconButton
                              color="error"
                              disabled={isReadOnly}
                              onClick={e => {
                                e.stopPropagation();
                                onDeleteComment(row.clientCommentId);
                              }}
                              sx={{
                                marginLeft: '-20px'
                              }}
                            >
                              <Delete />
                            </IconButton>
                            <Typography
                              sx={{
                                fontSize: 'inherit',
                                color: 'inherit',
                                lineHeight: 1.5,
                                marginLeft: '-15px'
                              }}
                            >
                              {serviceOptions.find(opt => opt.id === row.serviceId)?.title || ''}
                            </Typography>
                          </Box>
                        </Table.Cell>
                      );
                    }
                    return <Table.Cell {...props} />;
                  }}
                  rowComponent={props => {
                    const rowStyle = {
                      cursor: 'pointer',
                      backgroundColor: (props.row.clientCommentId === selectedComment?.clientCommentId) ? '#f5f5f5' : 'white'
                    };

                    const hoverStyle = {
                      backgroundColor: '#f5f5f5',
                      color: '#000'
                    };

                    return (
                      <Table.Row
                        {...props}
                        onClick={() => onRowClick(props.row)}
                        style={rowStyle}
                        onMouseEnter={e => {
                          Object.assign(e.currentTarget.style, hoverStyle);
                        }}
                        onMouseLeave={e => {
                          Object.assign(e.currentTarget.style, rowStyle);
                        }}
                      />
                    );
                  }}
                />
                <TableHeaderRow rowComponent={renderHeaderRow} showSortingControls />
                <TableFilterRow cellComponent={customFilterCell} />
                <PagingPanel pageSizes={pageSizes} />
              </Grid>
            </Paper>
          </Box>
          <Box flex={1}>
            <SelectedCommentAndNote
              selectedComment={selectedComment}
              setSelectedComment={setSelectedComment}
              setIsLoading={setIsLoading}
              clientRecordId={clientId}
              isNewComment={isNewComment}
              setIsNewComment={setIsNewComment}
              enumerations={enumerations}
              setFilteredRows={setFilteredRows}
              commentsAndNotesWithAttachments={details?.clientDetails?.clientComments}
              isReadOnly={isReadOnly}
              internalUsers={internalUsers}
            />
          </Box>
        </Box>
      )}
      {!isLoading && viewMode !== 'fullView' && (
        <Box display="flex" width="100%" height="100%">
          {!selectedComment && (
            <Box sx={{ padding: 3 }}>
              <Box sx={{ flexDirection: 'row' }}>
                <TextField
                  diabled={true}
                  placeholder="Search..."
                  InputProps={iconAdornment}
                  sx={{ paddingBottom: '10px' }}
                  value={filterText}
                  onChange={e => handleFilterChange(e)}
                />
                <Button color="primary" variant="contained" sx={{ marginLeft: '10px', marginTop: '5px' }} onClick={saveComment} disabled={isReadOnly}>
                  Create Comment
                </Button>
              </Box>
              <Paper>
                <Grid rows={filteredRows} columns={columns}>
                  <SortingState sorting={sorting} onSortingChange={setSorting} />
                  <IntegratedSorting />
                  <PagingState
                    currentPage={currentPage}
                    onCurrentPageChange={setCurrentPage}
                    pageSize={pageSize}
                    onPageSizeChange={setPageSize}
                  />
                  <FilteringState filters={filters} onFiltersChange={setFilters} />
                  <IntegratedFiltering />
                  <IntegratedPaging />
                  <Table
                    columnExtensions={tableColumnExtensions}
                    cellComponent={props => {
                      const { column, row, ...restProps } = props;
                      if (column.name === 'serviceId') {
                        return (
                          <Table.Cell {...restProps}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                              <IconButton
                                color="error"
                                disabled={isReadOnly}
                                onClick={e => {
                                  e.stopPropagation();
                                  onDeleteComment(row.clientCommentId);
                                }}
                                sx={{
                                  marginLeft: '-20px'
                                }}
                              >
                                <Delete />
                              </IconButton>
                              <Typography
                                sx={{
                                  fontSize: 'inherit',
                                  color: 'inherit',
                                  lineHeight: 1.5,
                                  marginLeft: '-15px'
                                }}
                              >
                                {serviceOptions.find(opt => opt.id === row.serviceId)?.title || ''}
                              </Typography>
                            </Box>
                          </Table.Cell>
                        );
                      }
                      return <Table.Cell {...props} />;
                    }}
                    rowComponent={props => {
                      const rowStyle = {
                        cursor: 'pointer',
                        backgroundColor: 'white'
                      };

                      const hoverStyle = {
                        backgroundColor: '#f5f5f5',
                        color: '#000'
                      };

                      return (
                        <Table.Row
                          {...props}
                          onClick={() => onRowClick(props.row)}
                          style={rowStyle}
                          onMouseEnter={e => {
                            Object.assign(e.currentTarget.style, hoverStyle);
                          }}
                          onMouseLeave={e => {
                            Object.assign(e.currentTarget.style, rowStyle);
                          }}
                        />
                      );
                    }}
                  />
                  <TableHeaderRow rowComponent={renderHeaderRow} showSortingControls />
                  <TableFilterRow cellComponent={customFilterCell} />
                  <PagingPanel pageSizes={pageSizes} />
                </Grid>
              </Paper>
            </Box>
          )}
          {selectedComment && (
            <Box flex={2}>
              <SelectedCommentAndNote
                selectedComment={selectedComment}
                setSelectedComment={setSelectedComment}
                setIsLoading={setIsLoading}
                clientRecordId={clientId}
                isNewComment={isNewComment}
                setIsNewComment={setIsNewComment}
                halfView={true}
                enumerations={enumerations}
                clientDetails={details}
                setFilteredRows={setFilteredRows}
                commentsAndNotesWithAttachments={details?.clientDetails?.clientComments}
                isReadOnly={isReadOnly}
              />
            </Box>
          )}
        </Box>
      )}
    </ThemeProvider>
  );
};

const mapStateToProps = state => ({});

export default compose(connect(mapStateToProps, { deleteClientComment, postClientComment, getAllClientComments, showToast }))(CommentsAndNotes);
